// if (!customElements.get('quick-add-bulk')) {
//   customElements.define(
//     'quick-add-bulk',
//     class QuickAddBulk extends BulkAdd {
//       constructor() {
//         super();
//         this.quantity = this.querySelector('quantity-input');

//         const debouncedOnChange = debounce((event) => {
//           if (parseInt(event.target.value) === 0) {
//             this.startQueue(event.target.dataset.index, parseInt(event.target.value));
//           } else {
//             this.validateQuantity(event);
//           }
//         }, ON_CHANGE_DEBOUNCE_TIMER);

//         this.addEventListener('change', debouncedOnChange.bind(this));
//         this.listenForActiveInput();
//         this.listenForKeydown();
//         this.lastActiveInputId = null;
//       }

//       connectedCallback() {
//         //console.log(' sectionId:', this.sectionId);
//         //console.log(' dataset index:', this.dataset.index);
//         this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
//           if (
//             event.source === 'quick-add' ||
//             (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
//             (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
//           ) {
//             return;
//           }
//           // If its another section that made the update
//           this.onCartUpdate().then(() => {
//             this.listenForActiveInput();
//             this.listenForKeydown();
//           });
//         });
//       }

//       disconnectedCallback() {
//         if (this.cartUpdateUnsubscriber) {
//           this.cartUpdateUnsubscriber();
//         }
//       }

//       get input() {
//         return this.querySelector('quantity-input input');
//       }

//       selectProgressBar() {
//         return this.querySelector('.progress-bar-container');
//       }

//       listenForActiveInput() {
//         if (!this.classList.contains('hidden')) {
//           this.input?.addEventListener('focusin', (event) => event.target.select());
//         }
//         this.isEnterPressed = false;
//       }

//       listenForKeydown() {
//         this.input?.addEventListener('keydown', (event) => {
//           if (event.key === 'Enter') {
//             this.input?.blur();
//             this.isEnterPressed = true;
//           }
//         });
//       }

//       cleanErrorMessageOnType(event) {
//         event.target.addEventListener(
//           'keypress',
//           () => {
//             event.target.setCustomValidity('');
//           },
//           { once: true }
//         );
//       }

// //       get sectionId() {
// //   if (!this._sectionId) {
// //     // 1. Try finding the standard bulk class used in Featured Collections
// //     const bulkWrapper = this.closest('.collection-quick-add-bulk');
    
// //     // 2. Try finding the recommendations wrapper (for Related Products)
// //     const recommendationsWrapper = this.closest('product-recommendations');
// //     console.log(recommendationsWrapper);
// //     this._sectionId = (bulkWrapper && bulkWrapper.dataset.id) || 
// //                       (recommendationsWrapper && recommendationsWrapper.dataset.sectionId) || 
// //                       this.dataset.sectionId;
// //   }
// //   return this._sectionId;
// // }
//       // get sectionId() {
//       //   if (!this._sectionId) {
//       //     this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
//       //   }

//       //   return this._sectionId;
//       // }
//         get sectionId() {
//           if (!this._sectionId) {
//             this._sectionId = this.closest('.collection-quick-add-bulk')?.dataset.id;
//             console.log(' computed sectionId:', this._sectionId);
//           }
//           return this._sectionId;
//         }
//       onCartUpdate() {
//         console.log(' sectionIdUpdate:', this.sectionId);
//         console.log(' dataset indexUpdate:', this.dataset.index);
//         return new Promise((resolve, reject) => {
//           fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
//             .then((response) => response.text())
//             .then((responseText) => {
//               const html = new DOMParser().parseFromString(responseText, 'text/html');
//               const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
//              console.log(sourceQty,'sourceQty');
//               if (sourceQty) {
//                 this.innerHTML = sourceQty.innerHTML;
//               }
//               resolve();
//             })
//             .catch((e) => {
//               console.error(e);
//               reject(e);
//             });
//         });
//       }

//       getSectionsUrl() {
//         const pageParams = new URLSearchParams(window.location.search);
//         const pageNumber = decodeURIComponent(pageParams.get('page') || '');

//         return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
//       }

//       updateMultipleQty(items) {
//         this.selectProgressBar().classList.remove('hidden');

//         const ids = Object.keys(items);
//         const body = JSON.stringify({
//           updates: items,
//           sections: this.getSectionsToRender().map((section) => section.section),
//           sections_url: this.getSectionsUrl(),
//         });

//         fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
//           .then((response) => {
//             return response.text();
//           })
//           .then((state) => {
//             const parsedState = JSON.parse(state);
//             this.renderSections(parsedState, ids);
//             publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
//           })
//           .catch(() => {
//             // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
//             e.target.setCustomValidity(error);
//             e.target.reportValidity();
//             this.resetQuantityInput(ids[index]);
//             //this.selectProgressBar().classList.add('hidden');
//             e.target.select();
//             this.cleanErrorMessageOnType(e);
//           })
//           .finally(() => {
//             this.selectProgressBar().classList.add('hidden');
//             this.setRequestStarted(false);
//           });
//       }

//       getSectionsToRender() {
//         return [
//           {
//             id: 'cart-icon-bubble',
//             section: 'cart-icon-bubble',
//             selector: '.shopify-section',
//           },
//           {
//             id: 'cart-icon-bubble-2',
//             section: 'cart-icon-bubble-2',
//             selector: '.shopify-section',
//           },
//           {
//             id: 'CartDrawer',
//             selector: '.drawer__inner',
//             section: 'cart-drawer',
//           },
//           {
//             id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
//             section: this.sectionId,
//             selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
//           },
//         ];
//       }
 
//       renderSections(parsedState, ids) {        
//         const intersection = this.queue.filter((element) => ids.includes(element.id));
//         if (intersection.length !== 0) return;
//         this.getSectionsToRender().forEach((section) => {
//           //console.log(section);
//           const sectionElement = document.getElementById(section.id);
//           if (section.section === 'cart-drawer') {
//             sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length.length === 0);
//           }
//           const elementToReplace =
//             sectionElement && sectionElement.querySelector(section.selector)
//               ? sectionElement.querySelector(section.selector)
//               : sectionElement;
              
//           if (elementToReplace) {
//             elementToReplace.innerHTML = this.getSectionInnerHTML(
//               parsedState.sections[section.section],
//               section.selector
//             );
//           }
//         });

//         if (this.isEnterPressed) {
//           this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
//         }

//         this.listenForActiveInput();
//         this.listenForKeydown();
//       }
//     }
//   );
// }
if (!customElements.get('quick-add-bulk')) {
    customElements.define(
        'quick-add-bulk',
        class QuickAddBulk extends BulkAdd {
            constructor() {
                super();
                this.quantity = this.querySelector('quantity-input');

                const debouncedOnChange = debounce((event) => {
                    if (parseInt(event.target.value) === 0) {
                        this.startQueue(event.target.dataset.index, parseInt(event.target.value));
                    } else {
                        this.validateQuantity(event);
                    }
                }, ON_CHANGE_DEBOUNCE_TIMER);

                this.addEventListener('change', debouncedOnChange.bind(this));
                this.listenForActiveInput();
                this.listenForKeydown();
                this.lastActiveInputId = null;
            }

            connectedCallback() {
                //console.log(' sectionId:', this.sectionId);
                //console.log(' dataset index:', this.dataset.index);
                this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                    if (
                        event.source === 'quick-add' ||
                        (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
                        (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
                    ) {
                        return;
                    }
                    // If its another section that made the update
                    this.onCartUpdate().then(() => {
                        this.listenForActiveInput();
                        this.listenForKeydown();
                    });
                });
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
            }

            get input() {
                return this.querySelector('quantity-input input');
            }

            selectProgressBar() {
                return this.querySelector('.progress-bar-container');
            }

            listenForActiveInput() {
                if (!this.classList.contains('hidden')) {
                    this.input?.addEventListener('focusin', (event) => event.target.select());
                }
                this.isEnterPressed = false;
            }

            listenForKeydown() {
                this.input?.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        this.input?.blur();
                        this.isEnterPressed = true;
                    }
                });
            }

            cleanErrorMessageOnType(event) {
                event.target.addEventListener(
                    'keypress',
                    () => {
                        event.target.setCustomValidity('');
                    },
                    { once: true }
                );
            }

            //       get sectionId() {
            //   if (!this._sectionId) {
            //     // 1. Try finding the standard bulk class used in Featured Collections
            //     const bulkWrapper = this.closest('.collection-quick-add-bulk');

            //     // 2. Try finding the recommendations wrapper (for Related Products)
            //     const recommendationsWrapper = this.closest('product-recommendations');
            //     console.log(recommendationsWrapper);
            //     this._sectionId = (bulkWrapper && bulkWrapper.dataset.id) || 
            //                       (recommendationsWrapper && recommendationsWrapper.dataset.sectionId) || 
            //                       this.dataset.sectionId;
            //   }
            //   return this._sectionId;
            // }
            // get sectionId() {
            //   if (!this._sectionId) {
            //     this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
            //   }

            //   return this._sectionId;
            // }
            get sectionId() {
                if (!this._sectionId) {
                    this._sectionId = this.closest('.collection-quick-add-bulk')?.dataset.id;
                   // console.log(' computed sectionId:', this._sectionId);
                }
                return this._sectionId;
            }
            onCartUpdate() {
               // console.log(' sectionIdUpdate:', this.sectionId);
               // console.log(' dataset indexUpdate:', this.dataset.index);
                return new Promise((resolve, reject) => {
                    let fetchUrl = this.getSectionsUrl();
                    if (fetchUrl.includes('?')) {
                        fetchUrl += `&section_id=${this.sectionId}`;
                    } else {
                        fetchUrl += `?section_id=${this.sectionId}`;
                    }

                    fetch(fetchUrl)
                        .then((response) => response.text())
                        .then((responseText) => {
                            const html = new DOMParser().parseFromString(responseText, 'text/html');
                            const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`) || html.querySelector(`quick-add-bulk[data-index="${this.dataset.index}"]`);
                           // console.log(sourceQty, 'sourceQty');
                            if (sourceQty) {
                                this.innerHTML = sourceQty.innerHTML;
                            }
                            resolve();
                        })
                        .catch((e) => {
                            console.error(e);
                            reject(e);
                        });
                });
            }

            getSectionsUrl() {
                const dynamicSection = this.closest('recently-viewed-products, product-recommendations');
                if (dynamicSection) {
                    const productIds = Array.from(dynamicSection.querySelectorAll('quick-add-bulk[data-product-id]'))
                        .map((el) => 'id:' + el.dataset.productId)
                        .filter((value, index, self) => self.indexOf(value) === index) // Unique IDs
                        .join(' OR ');
                    if (productIds) {
                        return (window.routes?.search_url || '/search') + '?type=product&q=' + encodeURIComponent(productIds);
                    }
                }

                const pageParams = new URLSearchParams(window.location.search);
                const pageNumber = decodeURIComponent(pageParams.get('page') || '');

                return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
            }

            updateMultipleQty(items) {
                this.selectProgressBar().classList.remove('hidden');

                const ids = Object.keys(items);
                const body = JSON.stringify({
                    updates: items,
                    sections: this.getSectionsToRender().map((section) => section.section),
                    sections_url: this.getSectionsUrl(),
                });

                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                    .then((response) => {
                        return response.text();
                    })
                    .then((state) => {
                        const parsedState = JSON.parse(state);
                        this.renderSections(parsedState, ids);
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
                    })
                    .catch(() => {
                        // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
                        e.target.setCustomValidity(error);
                        e.target.reportValidity();
                        this.resetQuantityInput(ids[index]);
                        //this.selectProgressBar().classList.add('hidden');
                        e.target.select();
                        this.cleanErrorMessageOnType(e);
                    })
                    .finally(() => {
                        this.selectProgressBar().classList.add('hidden');
                        this.setRequestStarted(false);
                    });
            }

            getSectionsToRender() {
                return [
                    {
                        id: 'cart-icon-bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section',
                    },
                    {
                        id: 'cart-icon-bubble-2',
                        section: 'cart-icon-bubble-2',
                        selector: '.shopify-section',
                    },
                    {
                        id: 'CartDrawer',
                        selector: '.drawer__inner',
                        section: 'cart-drawer',
                    },
                    {
                        id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
                        section: this.sectionId,
                        selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
                    },
                ];
            }

            renderSections(parsedState, ids) {
                const intersection = this.queue.filter((element) => ids.includes(element.id));
                if (intersection.length !== 0) return;
                this.getSectionsToRender().forEach((section) => {
                    //console.log(section);
                    const sectionElement = document.getElementById(section.id);
                    if (section.section === 'cart-drawer') {
                        sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length === 0);
                    }
                    const elementToReplace =
                        sectionElement && sectionElement.querySelector(section.selector)
                            ? sectionElement.querySelector(section.selector)
                            : sectionElement;

                    if (elementToReplace) {
                        const sectionHtml = parsedState.sections[section.section];
                        if (sectionHtml) {
                            const newHTML = this.getSectionInnerHTML(
                                sectionHtml,
                                section.selector
                            );
                            if (newHTML) {
                                elementToReplace.innerHTML = newHTML;
                            } else if (section.id.startsWith('quick-add-bulk')) {
                                this.onCartUpdate();
                            }
                        } else if (section.id.startsWith('quick-add-bulk')) {
                            this.onCartUpdate();
                        }
                    }
                });

                if (this.isEnterPressed) {
                    this.querySelector(`#Quantity-${this.lastActiveInputId}`)?.select();
                }

                this.listenForActiveInput();
                this.listenForKeydown();
            }
        }
    );
}